/**
 * @generated SignedSource<<e213f4c3215b162dc98ec07d575c2040>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoListEventData$data = {
  readonly created: string;
  readonly creators: ReadonlyArray<string>;
  readonly description: string | null | undefined;
  readonly id: string;
  readonly isLive: boolean;
  readonly series: {
    readonly id: string;
    readonly title: string;
  } | null | undefined;
  readonly syncedData: {
    readonly audioOnly: boolean;
    readonly duration: number;
    readonly endTime: string | null | undefined;
    readonly startTime: string | null | undefined;
    readonly thumbnail: string | null | undefined;
  } | null | undefined;
  readonly title: string;
  readonly " $fragmentType": "VideoListEventData";
};
export type VideoListEventData$key = {
  readonly " $data"?: VideoListEventData$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoListEventData">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "VideoListEventData"
};

(node as any).hash = "5ded3b327f00894c64bc1089c4574d3a";

export default node;
